import React from 'react';
import { Outlet } from 'react-router-dom';
import AllIndividuals from '../components/individuals/AllIndividuals';

const IndividualsLayout = () => {
  return (
    <>
      {/* AllIndividuals reste toujours montée */}
      <AllIndividuals />

      {/* Outlet pour les routes enfants (IndividualDetailPage) qui s'affichent par-dessus */}
      <Outlet />
    </>
  );
};

export default IndividualsLayout;
